module.exports = __webpack_public_path__ + "img/header-weddingRingsGayLesbianCouples@2x.e127576.jpg";